import { DataMonitoringType } from "../../../common/types/dataMonitoring";
import { DataFlowItem } from "../../atoms/DataFlowItem";
import * as S from "./DataFlow.style";

interface DataFlowProps {
  data?: DataMonitoringType;
}

export const DataFlow = ({ data }: DataFlowProps) => {
  return (
    <S.DataFlowBox>
      <S.FlowLabelBox>
        <S.FlowLabel>데이터 구분</S.FlowLabel>
        <S.FlowLabel>Last Sending Time</S.FlowLabel>
      </S.FlowLabelBox>

      <S.FlowList>
        <DataFlowItem unit="ecs" />
        <DataFlowItem
          unit="save"
          status={data?.collectionStatus}
          date={data?.date}
          active={true} //상위 값이 errored => false, 그외는 true
        />
        <DataFlowItem
          unit="send"
          status={data?.sendStatus}
          date={data?.date}
          active={data?.collectionStatus === "errored" ? false : true}
        />
        <DataFlowItem
          unit="received"
          status={data?.receptionStatus}
          date={data?.date}
          active={data?.sendStatus === "errored" ? false : true}
        />
      </S.FlowList>
    </S.DataFlowBox>
  );
};
